import React from 'react';
import { STATUS_COLORS } from '../../../constants/status-colors';
import type { BadgeProps, BadgeSize } from './types';

// ─── Size class map (exported for snapshot testing) ──────────────────────────

export const SIZE_CLASSES: Record<BadgeSize, string> = {
  sm: 'h-5 px-2 text-xs gap-1',
  md: 'h-6 px-2.5 text-xs gap-1.5',
};

const DOT_SIZES: Record<BadgeSize, string> = {
  sm: 'h-1.5 w-1.5',
  md: 'h-2 w-2',
};

const PULSING_VARIANTS = new Set(['overdue', 'conflict', 'pendingSync']);

// ─── Badge ────────────────────────────────────────────────────────────────────

export function Badge({
  variant = 'draft',
  size = 'md',
  dot = false,
  children,
  className,
}: BadgeProps) {
  const colors = STATUS_COLORS[variant];
  const isPulsing = PULSING_VARIANTS.has(variant);

  const classes = [
    'inline-flex items-center font-medium rounded-full whitespace-nowrap border',
    SIZE_CLASSES[size],
    colors.bg,
    colors.text,
    colors.border,
    isPulsing ? 'animate-pulse-soft' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span role="status" className={classes}>
      {dot && (
        <span
          className={['rounded-full shrink-0', DOT_SIZES[size], colors.dot].join(' ')}
          aria-hidden="true"
        />
      )}
      {children}
    </span>
  );
}
